import { Portal } from '@gorhom/portal';
import React, {
  forwardRef,
  Fragment,
  ReactNode,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { View } from 'react-native';

import {
  TooltipContent,
  TooltipPositionEnum,
} from './TooltipContent';

export type TooltipRefType = {
  toggle(): void;
};

export interface ITooltipProps {
  position?: TooltipPositionEnum;
  children: ReactNode;
  offset?: number;
  text: string;
}

export const Tooltip = forwardRef<TooltipRefType, ITooltipProps>(
  ({ children, ...props }, ref) => {
    const targetRef = useRef<View>(null);
    const [visible, setVisible] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
      toggle: () => setVisible((v) => !v),
    }));

    function hoverStart() {
      setVisible(true);
    }

    function hoverEnd() {
      setVisible(false);
    }

    return (
      <Fragment>
        <View
          ref={targetRef}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          onMouseEnter={hoverStart}
          onMouseOver={hoverStart}
          onMouseLeave={hoverEnd}
        >
          {children}
        </View>

        {visible && (
          <Portal>
            <TooltipContent
              {...props}
              onClose={hoverEnd}
              targetRef={targetRef}
            />
          </Portal>
        )}
      </Fragment>
    );
  },
);
